<template>
  <v-container
    fluid>
    <v-col
      cols="12"
      md="8"
      v-if="showPrintOption && printUrl"
    >
      <a
        :href="printUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <v-btn
          class="ma-4"
          :style="{ backgroundColor: 'teal', color: '#FFFFFF' }"
        >
          Print
        </v-btn>
      </a>
    </v-col>

    <v-row
      justify="center">
      <v-col
        class="pt-4"

        cols="10"
        md="8">
        <v-select
          :items="subjects"
          :value="selectedSubject"
          @change="changeSubject"
          label="Select a blog..."
        />
      </v-col>
      <v-col
        cols="12"
        md="8"
        v-if="publishedBlogs.length === 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          No blog entries available to view.
        </v-alert>
      </v-col>
      <v-col
        class="pt-2"
        cols="12"
        md="8"
        v-for="publishedBlog in orderedBlogs"
        :key="publishedBlog.evidence_id">
        <v-card class="mb-3  elevation-0">
          <v-card-title class="font-weight-bold subtitle-2">
            <v-avatar
              size="30"
              v-if="publishedBlog.pupilIDposted == pupilLoggedIn">
              <v-img
                @error="pupilPhotoToUse = './img/photo.png'"
                :src="pupilPhotoToUse"/>
            </v-avatar>
            &nbsp;&nbsp;{{ publishedBlog.pupilPosted }} posted to {{ publishedBlog.descript }}
          </v-card-title>
          <v-card>
            <template v-if="publishedBlog.carouselPhotos.length === 1">
              <v-img :src="publishedBlog.carouselPhotos[0].blogUrl" />
              <v-btn
                :href="publishedBlog.carouselPhotos[0].blogUrl"
                target="_blank"
              >
                <v-icon>fa-download</v-icon>
              </v-btn>
            </template>
            <template v-else-if="publishedBlog.carouselPhotos.length > 1">
              <v-carousel
                hide-delimiters
                height="auto">
                <v-carousel-item
                  v-for="(item, i) in publishedBlog.carouselPhotos"
                  :key="i">
                  <v-img :src="item.blogUrl"/>
                  <v-btn
                    :href="item.blogUrl"
                    target="_blank"
                    style="margin-top: 10px;">
                    <v-icon>fa-download</v-icon>
                  </v-btn>
                </v-carousel-item>
              </v-carousel>
            </template>
          </v-card>
          <v-card-text
            v-for="(blogImageDetails, i) in publishedBlog.evMediaArr"
            :key="'A' + i"
            class="pa-2 text-center">
            <v-card>
              <v-btn
                :href="blogImageDetails.blogUrl"
                class="mt-3 mb-3"
                target="_blank"
                style="text-decoration: none;"
                v-if="!isImage(blogImageDetails.fileextension)"
              >
                <span>Open {{ getFileExtension(blogImageDetails.fileextension) }} <v-icon>fa-external-link-alt</v-icon></span>
              </v-btn>
            </v-card>
          </v-card-text>

          <v-card-text
            style="overflow-wrap: break-word;"
            v-if="publishedBlog.studentComment !== null && publishedBlog.studentComment !== ''">
            <v-icon color="orange">fa-comment</v-icon> {{ publishedBlog.pupilPosted }} <span v-html="convertURLsToHreftest(publishedBlog.studentComment)"/>
          </v-card-text>

          <v-card-text
            style="overflow-wrap: break-word; background-color: #f9f9f9; padding: 10px; border-radius: 5px;"
            class="pb-0"
            v-if="publishedBlog.teacherComment !== null && publishedBlog.teacherComment !== ''">
            <v-icon color="teal">fa-comment</v-icon>
            <strong style="color: teal;"> {{ publishedBlog.author }}</strong>
            <span style="color: teal;"> - </span>
            <span
              class="font-weight-regular"
              v-html="convertURLsToHreftest(publishedBlog.teacherComment)" />
          </v-card-text>

          <template v-if="publishedBlog.parentComments.length !== 0">
            <v-card-text
              class="pb-0"
              v-for="(eachCommentData, cmtInd) in publishedBlog.parentComments"
              :key="cmtInd"
              style="margin-bottom: 10px; padding-bottom: 5px;">
              <v-card-text
                style="overflow-wrap: break-word; background-color: #f9f9f9; padding: 10px; border-radius: 5px;"
                class="pb-0"
                v-if="eachCommentData.content !== null && eachCommentData.content !== ''">
                <v-icon color="blue">fas fa-comments</v-icon>
                <strong style="color: #1E88E5;"> {{ eachCommentData.author }}</strong>
                <span style="color: #1E88E5;"> - </span>
                <span class="font-weight-regular">{{ eachCommentData.content }}</span>
              </v-card-text>
            </v-card-text>
          </template>

          <v-card-actions class="caption ml-2 grey--text">{{ publishedBlog.formattedPubDate }}
            <v-spacer/>
            <v-tooltip
              top>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  @click="openFeedbackDialog(publishedBlog.blogPsid, publishedBlog.blogEvidence)">
                  <v-icon>comment</v-icon>
                </v-btn>
              </template>
              <span v-if="allowComment">Post Comment</span>
              <span v-else>Feedback</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="commentDialog"
      v-if="allowComment">
      <v-card>
        <v-card-title class="pb-0 subtitle-1">Feedback</v-card-title>
        <v-card-text
          class="red--text pt-0 pb-0"
          v-if="commentErrorMsg !== ''">{{ commentErrorMsg }}</v-card-text>
        <v-card-text class="pb-0">
          <v-textarea
            auto-grow
            rows="3"
            name="comment-input"
            label="Enter a comment"
            v-model="comment"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            text
            @click.native="commentDialog = false; comment = ''; commentErrorMsg = ''">Close</v-btn>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click.native="saveComment()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="feedbackDialog"
      max-width="290px"
      v-else>
      <v-card>
        <v-card-title>Feedback</v-card-title>
        <v-card-text>
          <v-row
            class="fill-height"
            align="center"
            justify="space-around"

          >
            <v-tooltip
              top
              v-for="(feedback, i) in possibleFeedback"
              :key="i">
              <v-btn
                icon
                @click="saveFeedback(feedback.message)"
                slot="activator">
                <v-icon>{{ feedback.icon }}</v-icon>
              </v-btn>
              <span>{{ feedback.message }}</span>
            </v-tooltip>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            text
            @click.native="feedbackDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
var orderBy = require('lodash.orderby')

export default {
  data: () => ({
    subjects: ['ALL'],
    selectedSubject: 'ALL',
    publishedBlogs: [],
    pupilPhotoToUse: '',
    allowComment: true,
    commentPSID: 0,
    commentTaskId: 0,
    commentblogEvidence: 0,
    showPrintOption: false,
    printUrl: '',

    // Comment dialog
    commentDialog: false,
    comment: '',
    commentErrorMsg: '',
    disableFeedback: false,

    // Emoji feedback dialog
    feedbackDialog: false,
    possibleFeedback: [
      {
        icon: 'far fa-star',
        message: 'You\'re a star!'
      },
      {
        icon: 'far fa-heart',
        message: 'Love it!'
      },
      {
        icon: 'far fa-thumbs-up',
        message: 'Good job!'
      },
      {
        icon: 'far fa-smile',
        message: 'Awesome! :)'
      }
    ]
  }),

  computed: {
    pupilPhoto: function () { return this.$store.getters.pupilPhoto },
    pupilPreferredName: function () { return this.$store.getters.pupilPreferredName },
    pupilLoggedIn: function () { return this.$store.state.pupilId },
    orderedBlogs: function () {
      if (Object.keys(this.publishedBlogs).length > 0) { // Check if publishedBlogs array is not empty
        let obj = this.publishedBlogs[Object.keys(this.publishedBlogs)[0]]

        if ('datePub' in obj) {
          return orderBy(this.publishedBlogs, 'datePub', 'desc')
        } else {
          return this.publishedBlog
        }
      } else {
        return this.publishedBlogs
      }
    }
  },
  onIdle () {
    if (this.$store.state.withPin && this.$store.state.withPin === true) {
      this.$router.push({ path: '/pin', replace: true })
    }
  },
  methods: {
    // downloadThis (url) {
    //   fetch(url)
    //     .then(response => response.blob())
    //     .then(blob => {
    //       const blobUrl = URL.createObjectURL(blob)
    //       const link = document.createElement('a')
    //       link.href = blobUrl
    //       link.download = 'image.jpg'
    //       document.body.appendChild(link)
    //       link.click()
    //       document.body.removeChild(link)
    //       URL.revokeObjectURL(blobUrl)
    //     })
    //     .catch(error => {
    //       console.error('Error downloading image:', error)
    //     })
    // },
    openFeedbackDialog: function (psid, evidenceId) {
      this.commentPSID = psid
      this.blogEvidence = evidenceId

      if (this.allowComment) {
        this.commentDialog = true
      } else {
        if (this.disableFeedback !== true) {
          this.feedbackDialog = true
        }
      }
    },
    convertURLsToHref: function (stringToConvert) {
      return stringToConvert.replace(/(http)(s)?(:\/\/)(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/g, "<a href='http$2://$4' class='v-btn theme--light' style='text-decoration: none;' target='_blank' title='$&'>Open Link</a>")
    },
    convertURLsToHreftest: function (stringToConvert) {
      return stringToConvert.replace(/(http)(s)?(:\/\/)(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/, "<a href='http$2://$4' target='_blank' title='$&' style='color:blue;'>$&</a>")
    },
    shouldHideControls: function (imagesArr) {
      return imagesArr.length <= 1
    },

    changeSubject: function (selection) {
      if (selection !== this.selectedSubject) {
        this.selectedSubject = selection

        this.$store.commit('loading', true)
        this.$http.get('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.pupilId + '/spotlightV2/blogV2/' + this.selectedSubject)
          .then(resp => {
            this.publishedBlogs = resp.data.publishedBlogs
            this.$store.commit('loading', false)
          })
      }
    },
    fixURLHttpPrefix: function (stringToFix) {
      return stringToFix.replace(/(http)?(s)?(:\/\/)?(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/g, 'http$2://$4')
    },
    isImage: function (stringToCheck) {
      if (stringToCheck) {
        let imageExtensions = ['.png', '.jpeg', '.jpg', '.gif']
        return imageExtensions.some(imgExt => stringToCheck.toLowerCase().includes(imgExt.toLowerCase()))
      }
    },
    getFileExtension: function (string) {
      if (string) {
        return string.split('.').pop()
      }
    },
    saveComment: function () {
      this.$store.commit('loading', true)
      var comment = this.comment
      var psid = this.commentPSID
      var cid = this.$store.state.userId
      var taskid = this.commentTaskId
      var pupilCommentId = this.$store.state.pupilId
      var evidenceId = this.blogEvidence

      if (comment !== '') {
        this.$http.post('spotlightV2/blogParentCommentV2/' + this.$store.state.Dbasename, {
          'psid': psid,
          'content': comment,
          'caregiverId': cid,
          'taskId': taskid,
          'pupilCommentId': pupilCommentId,
          'evidenceId': evidenceId
        })
          .then(resp => {
            if (resp.data.success) {
              this.commentDialog = false
              this.comment = ''
              this.commentErrorMsg = ''
              this.commentPSID = 0
              this.$store.commit('loading', false)
            } else {
              this.commentErrorMsg = 'Something happen'
              this.$store.commit('loading', false)
            }
          })
      } else {
        this.commentErrorMsg = 'Comment cannot be blank. Please enter a comment before saving.'
        this.$store.commit('loading', false)
      }
    },

    saveFeedback: function (message) {
      this.$store.commit('loading', true)
      var psid = this.commentPSID
      var cid = this.$store.state.userId
      var pupilCommentId = this.$store.state.pupilId
      var evidenceId = this.blogEvidence
      var taskid = this.commentTaskId

      this.$http.post('spotlightV2/blogParentCommentV2/' + this.$store.state.Dbasename, {
        'psid': psid,
        'content': message,
        'caregiverId': cid,
        'taskId': taskid,
        'pupilCommentId': pupilCommentId,
        'evidenceId': evidenceId
      })
        .then(resp => {
          if (resp.data.success) {
            this.feedbackDialog = false
            this.commentPSID = 0
            this.$store.commit('loading', false)
          }
        })
    }
  },
  mounted: function () {
    this.$store.dispatch('logReadItems')
    this.pupilPhotoToUse = this.pupilPhoto
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // Get Blog Entries
      // Get config for allow parent comments
      vm.$http.get('https://www.atschool.co.nz/api/v2/configV2/' + vm.$store.state.Dbasename + '/' + 'atschoolBlogDisableParentComment')
        .then(resp => {
          vm.$http.get('https://www.atschool.co.nz/api/v2/pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.userId + '/checkBlogCommentStatusV2')
            .then(response => {
              if (resp.data.configValue && response.data.configValue !== vm.$store.state.userId.toString()) {
                vm.allowComment = true
              } else {
                vm.allowComment = false
              }
            })
        })

      vm.$http.get('https://www.atschool.co.nz/api/v2/blogV2/getBlogPrint/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId)
        .then(resp => {
          vm.showPrintOption = resp.data.blogConfig
          vm.printUrl = resp.data.url
        })

      vm.$http.get('https://www.atschool.co.nz/api/v2/pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/spotlightV2/blogV2')
        .then(resp => {
          vm.publishedBlogs = resp.data.publishedBlogs
          Object.keys(vm.publishedBlogs).map((value, key) => {
            if (!vm.subjects.includes(vm.publishedBlogs[value].descript)) {
              vm.subjects.push(vm.publishedBlogs[value].descript)
            }
          })
          vm.$store.commit('loading', false)
          vm.$store.commit('toggle_dialog', true)
        })
    })
  }
}
</script>

<style>
/* .v-carousel__controls {
  background: none!important;
} */
</style>
